module.exports = __webpack_public_path__ + "static/img/9bg_11.83cf65a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/9bg_11.png
// module id = 763
// module chunks = 1